import { render, staticRenderFns } from "./SignupPost.vue?vue&type=template&id=08515aff"
import script from "./SignupPost.vue?vue&type=script&lang=js"
export * from "./SignupPost.vue?vue&type=script&lang=js"
import style0 from "./SignupPost.vue?vue&type=style&index=0&id=08515aff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports